export const PaymentStatus = {
    PAID: "PAID",
    PENDING: "PENDING"
};